import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const CostCenterRoutes = [
  {
    path: '/cost-centers',
    name: 'ListCostCenters',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'cost_center:list'
    }
  },
  {
    path: '/cost-center',
    name: 'CreateCostCenters',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'cost_center:create'
    }
  },
  {
    path: '/cost-center/:id',
    name: 'UpdateCostCenters',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'cost_center:update'
    }
  },
  {
    path: '/cost-center/view/:id',
    name: 'GetCostCenters',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'cost_center:get'
    }
  }
]
